@if (showBreadcrumb) {
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      @for (breadcrumbRoute of breadcrumbRoutes; track breadcrumbRoute; let last = $last) {
        <li class="breadcrumb-item">
          <a (click)="focusOnLeftMenu(breadcrumbRoute)" [style]="getCursorStyle(breadcrumbRoute)" [ngClass]="last ? 'current-path' : 'past-path'">
            <span [innerText]="(breadcrumbRoute.name|translate)" [ngClass]="{'disabled-item':shouldNotRoute(breadcrumbRoute)}"></span>
          </a>
        </li>
      }
    </ol>
  </nav>
}
